<template>
  <div class="white">
    <div class="bg-contact">
      <v-img
        :src="imgUrl('bg-contact.jpg')"
        :aspect-ratio="4"
      ></v-img>
    </div>
    <v-container>
      <div v-translate
        class="text-center rounded-xl py-8 mx-auto font-weight-bold text-h4 text-uppercase topicContact"
      >
        Partnership</div>
        <div class="text-center mt-6 contentContact">
          <translate>You want to offer something interesting, fill out the form and we will get back to you as soon as possible.</translate>
        </div>
        <PartnershipForm />
    </v-container>
  </div>
</template>

<script>
import PartnershipForm from "@/components/Contact/PartnershipForm"
export default {
  name: 'Contact',
  components: {PartnershipForm},
  data() {
    return {}
  },
  methods: {}
}
</script>

